export const ID56 = ()=> {
    return (
        <div>
            <h2 >Управление финансами строительной организации для Казахстана</h2>
            <div className="content" readonly="">
                <div className="section__tab" id="01" >
                    <div className="about-card__title">«1С-Рейтинг: Управление финансами строительной организации для
                        Казахстана» - комплексное решение, предназначенное для автоматизации бухгалтерского, налогового
                        и управленческого учета на&nbsp; предприятиях строительной отрасли, в том числе:<br/></div>
                    <ul>
                        <li >учет и планирование
                            строительно-монтажных работ по объектам строительства и стройкам;
                        </li>
                        <li>бюджетирование: составление мастер-бюджетов (бюджет доходов и расходов, бюджет движения
                            денежных средств, прогнозный баланс) и других оборотных бюджетов;
                        </li>
                        <li>автоматическое отражение фактических данных в бюджетах, анализ отклонений;</li>
                        <li>планирование и оперативное управление потоками денежных средств (казначейство);</li>
                        <li>управление договорными отношениями;</li>
                        <li>управление снабжением и закупками;</li>
                        <li>бухгалтерский и налоговый учет в соответствии с законодательством Республики Казахстан;</li>
                        <li>расчет заработной платы и кадровый учет;</li>
                        <li>выстраивание и использование различных схем коллективного согласования и утверждения
                            документов.
                        </li>
                    </ul>
                    <ul>
                        <ul>
                        </ul>
                    </ul>
                    <div>
                        «1С-Рейтинг: Управление финансами строительной организации для Казахстана» разработан на версии
                        8.3 платформы «1С:Предприятие» в режимах обычного (регламентированный учет) и управляемого
                        (управленческий учет) приложения.
                    </div>
                    <div>
                        Функционально конфигурация «1С-Рейтинг: Управление финансами строительной организации для
                        Казахстана» объединяет возможности решений <span href="http://1c-rating.kz/sol/compfin">«1С-Рейтинг: Комплексное управление финансами и бюджетирование для Казахстана»</span> и <span
                        href="http://1c-rating.kz/sol/bso">«1С:Бухгалтерия строительной организации для Казахстана»</span>,
                        тем самым обеспечивая:
                    </div>
                    <ul>
                        <li >простоту
                            обучения партнеров и клиентов работе с новым прикладным решением;
                        </li>
                        <li>возможность быстрой адаптации существующих проектных наработок к новому продукту;</li>
                        <li>невысокую стоимость миграции с уже используемых учетных систем. <br/>
                        </li>
                    </ul>
                    <div align="justify">
                        Прикладное решение может использоваться как комплексная система, объединяющая в одной
                        информационной базе бухгалтерский и налоговый учет с полноценным кадровым учетом и расчетом
                        заработной платы, предоставляющая дополнительные преимущества за счет взаимодействия подсистем в
                        едином информационном пространстве с одной стороны, и гибко разграничивающая доступ
                        пользователей к информации с другой, что очень важно для предприятий, использующих корпоративные
                        информационные системы.
                    </div>
                    <br/>
                </div>
            </div>
        </div>
    )
}